import { render, staticRenderFns } from "./CartDrawer.vue?vue&type=template&id=4f56ea56"
import script from "./CartDrawer.vue?vue&type=script&lang=js"
export * from "./CartDrawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports